import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { SseService } from '../sse.service';
import * as SseActions from '../store/actions/sse.action';
import { CitiesService } from '../../cities/services/cities.service';
import  * as ordersSelectors from '../../orders/store/selectors/orders.selector';
import * as ordersActions from '../../orders/store/actions/orders.action';
import * as ridersActions from '../../riders/store/actions/riders.action';
import { Store } from '@ngrx/store';
import { environment } from 'src/environments/environment';

interface RiderLocationEvent {
  rider_id: number;
  latitude: number;
  longitude: number;
}

@Injectable()
export class SseEffects {

  totalItems: number;
  totalPages: number;
  constructor(
    private actions$: Actions,
    private sseService: SseService,
    private citiesService: CitiesService,
    private store: Store
  ) {
    this.store.select(ordersSelectors.selectTotalItems).subscribe(totalItems => {
      this.totalItems = totalItems;
    });
    this.store.select(ordersSelectors.selectTotalPages).subscribe(totalPages => {
      this.totalPages = totalPages;
    });
  }

  userSelectedCityId = this.citiesService.getUserSelectedCityId();
  sseServerUrl = environment.sseServerUrl;

  getServerSentEventsToOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SseActions.getServerSentEventsToOrders),
      mergeMap(() =>
        this.sseService.getServerSentEventToOrders(`${this.sseServerUrl}/subscribe/${this.userSelectedCityId}-new-service`).pipe(
         
          map((event) => ordersActions.loadPendingOrders({ page: this.totalPages, limit: 100 })),
          catchError((error) => of(SseActions.getServerSentEventsToOrdersFailure({ error })))
        )
      )
    )
  );


  getServerSentEventsToRidersLocations$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SseActions.getServerSentEventsToRidersLocations),
      mergeMap(() =>
        this.sseService.getServerSentEventsToRidersLocations(`${this.sseServerUrl}/subscribe/${this.userSelectedCityId}-rider-location`).pipe(
          
          map((event: MessageEvent) => {
            const data: RiderLocationEvent = JSON.parse(event.data);
            return ridersActions.refreshRiderLocations({
              rider_id: data.rider_id,
              latitude: data.latitude,
              longitude: data.longitude
            });
          }),
          catchError((error) => of(SseActions.getServerSentEventsToRidersLocationsFailure({ error })))
        )
      )
    )
  );

  getServerSentEventsToRider$ = createEffect(() =>
    this.actions$.pipe(
      ofType(SseActions.getServerSentEventsToRider),
      mergeMap(() =>
        this.sseService.getServerSentEventsToRider('rider-url').pipe(
          map((event) => SseActions.getServerSentEventsToRiderSuccess({ data: event })),
          catchError((error) => of(SseActions.getServerSentEventsToRiderFailure({ error })))
        )
      )
    )
  );
}